import React, { useEffect } from 'react';
import styled from 'styled-components';
import { THEME_COLORS } from '../utils/theme';

interface ExternalRedirectProps {
  url: string;
}

const RedirectContainer = styled.div`
  width: 100vw;
  height: 90vh;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;

  color: ${THEME_COLORS.text};
`;

const Link = styled.a`
  color: ${THEME_COLORS.text};
`;

// const Spinner = styled.img.attrs({
//   src: spinnerIcon,
//   alt: 'Redirecting...',
// })`
//   animation: spin 1.5s infinite linear;
//   width: 30px;
//   margin-bottom: 20px;
//
//   @keyframes spin {
//     0% {
//       transform: rotate(0deg);
//     }
//     100% {
//       transform: rotate(360deg);
//     }
//   }
// `;

export const ExternalRedirect: React.FC<ExternalRedirectProps> = (props: ExternalRedirectProps) => {
  useEffect(() => {
    window.location.replace(props.url);
  });

  return (
    <RedirectContainer>
      {/*<Spinner />*/}
      <div>
        If you aren't automatically redirected, please click <Link href={props.url}>here</Link>.
      </div>
    </RedirectContainer>
  );
};
